/**
 * Money/percent formatting shared by the merged table's price columns and the
 * offer totals footer. Moved out of the retired `pricing-tab-columns.tsx` when
 * the Wyceny tab folded into the merged Nośniki table (CU-86cbc3r8b).
 */
const PL_LOCALE = 'pl-PL';
const PLN_CODE = 'PLN';
const PLN_SYMBOL = 'zł';
const PCT_SYMBOL = '%';

/** Format a monetary value using Polish locale. e.g. 1234.5 PLN -> "1 234,50 zł" */
export function formatMoney(value: number, currency: string): string {
  try {
    return new Intl.NumberFormat(PL_LOCALE, { style: 'currency', currency }).format(value);
  } catch {
    // Fallback if currency code is invalid
    return new Intl.NumberFormat(PL_LOCALE, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(value);
  }
}

/** Format a percentage value using Polish locale. e.g. 10.5 -> "10,5 %" */
export function formatPercent(value: number): string {
  return (
    new Intl.NumberFormat(PL_LOCALE, {
      minimumFractionDigits: 1,
      maximumFractionDigits: 1,
    }).format(value) +
    ' ' +
    PCT_SYMBOL
  );
}

/** Map ISO currency code to display symbol for PriceInput. */
export function currencySymbol(currency: string): string {
  return currency === PLN_CODE ? PLN_SYMBOL : currency;
}

export { PCT_SYMBOL };
